import React, { useState, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import useSWR from 'swr';
import { useLanguage } from '../../../../../contexts/languageContext';
import useFetcher from '../../../../../utils/hooks/useFetcher';
import { DashboardParams } from '../../../../Dashboard/dashboardInterfaces';
import { QUESTION_TYPE } from '../../constants';
import { SelectIndicatorQuestionContentProps, TypeOfQuestionIdProps, SelectedQuestionProps } from '../../dashboardModalInterface';
import ActionsButton from '../ActionsButton/actionButton';
import CardQuestionModal from '../CardQuestionModal/cardQuestionModal';
import { FormControlStyled } from '../styled';

const SelectIndicatorCrossingQuestion: FC<SelectIndicatorQuestionContentProps> = ({
    setCurrentContent,
    setCreateIndicator,
    setSelectedQuestion,
    selectedQuestion,
}) => {
    const { t } = useTranslation();
    const { surveyId, dashboardId } = useParams<DashboardParams>();
    const [typeOfQuestionId, setTypeOfQuestionId] = useState<TypeOfQuestionIdProps>(
        {
            id: undefined,
        },
    );
    const { selectedLanguage } = useLanguage();
    const selectedLanguageForSurvey = selectedLanguage && selectedLanguage.surveysLanguagesIds.find((surveyLanguage) => String(surveyLanguage.surveyId) === surveyId);
    const { data, error } = useSWR((selectedLanguageForSurvey && !selectedLanguageForSurvey.isDefault) ? `${process.env.REACT_APP_API_URL}/survey/${surveyId}/dashboard/${dashboardId}/questions/?translate=${selectedLanguageForSurvey.languageId}` : `${process.env.REACT_APP_API_URL}/survey/${surveyId}/dashboard/${dashboardId}/questions/`, useFetcher());
    const fetchedQuestionsToDisplay = data?.filter((item: SelectedQuestionProps) => item.type === 'ClosedData');

    if (error) { console.info('error', error); }

    const handleClick = () => {
        if (selectedQuestion.type === QUESTION_TYPE.OPEN || selectedQuestion.type === QUESTION_TYPE.NUMERIC) {
            setCurrentContent('selectDisplayType');
        } else {
            setCurrentContent('refineCrossingIndicatorAnswer');
        }
        setCreateIndicator((prev) => {
            const indicatorCopy = { ...prev };
            indicatorCopy.crossingQuestionId = typeOfQuestionId.id!;
            indicatorCopy.saveCrossingModalities = [];
            indicatorCopy.saveCrossingModalitiesGroup = [];
            indicatorCopy.saveCrossingTreeItems = [];

            return indicatorCopy;
        });
    };

    return (
        <>
            <FormControlStyled>
                {fetchedQuestionsToDisplay?.map((questionElement:SelectedQuestionProps) => (
                    <CardQuestionModal
                        key={questionElement.question_id}
                        question={questionElement}
                        setSelectedQuestion={setSelectedQuestion}
                        setTypeOfQuestionId={setTypeOfQuestionId}
                        typeOfQuestionId={typeOfQuestionId}
                    />

                ))}
            </FormControlStyled>
            <ActionsButton
                handleClickBack={() => setCurrentContent('selectDisplayType')}
                handleClickNext={handleClick}
                isDisabled={typeOfQuestionId.id === undefined}
                labelBack={t('back')}
                labelNext={t('next')}
            />
        </>
    );
};

export default SelectIndicatorCrossingQuestion;
